import React from 'react';
import { SideLink } from './sidelink/sidelink';
import { LinkProps } from 'config/links';

export const SideLinks = ({ links }: { links: LinkProps[] }) => {
  return (
    <>
      {links.map((link) => (
        <React.Fragment key={link.label}>
          <SideLink
            id={link.label}
            path={link.path}
            icon={link?.icon}
            label={link.label}
            subLinks={link.subLinks}
            key={link.label.toString()}
          />
        </React.Fragment>
      ))}
    </>
  );
};
